import { render, staticRenderFns } from "./RegisterSubscribe.view.vue?vue&type=template&id=70896daf&"
import script from "./RegisterSubscribe.view.vue?vue&type=script&lang=js&"
export * from "./RegisterSubscribe.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports